import { render } from "./OrgStructure.vue?vue&type=template&id=54cd97af&scoped=true"
import script from "./OrgStructure.vue?vue&type=script&lang=js"
export * from "./OrgStructure.vue?vue&type=script&lang=js"

import "./org-structure.scss?vue&type=style&index=0&id=54cd97af&lang=scss&scoped=true"
import "./OrgStructure.vue?vue&type=style&index=1&id=54cd97af&lang=scss"

import exportComponent from "D:\\fz\\1_Task\\hr.haite.sg\\orangehrm-5.2\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54cd97af"]])

export default __exports__